"use client";

import { sendGTMEvent } from "@next/third-parties/google";

import type { ProductDataLayerType } from "./types";
import { GTagEvents } from "./types";

type SelectItemProps = {
  item: ProductDataLayerType;
};

export const selectItemEvent = ({ item }: SelectItemProps) => {
  sendGTMEvent({
    event: GTagEvents.SELECT_ITEM,
    items: [item],
  });
};
